/**
 * Next.js Router Compatibility Shim
 *
 * During the Pages Router → App Router migration, components using
 * `useRouter` from `next/router` throw "NextRouter was not mounted"
 * in App Router context (e.g., static prerendering of `/_not-found`).
 *
 * This shim provides a safe `useRouter` that returns a stub router object
 * instead of throwing when the Pages Router context isn't available.
 *
 * Webpack alias in next.config.js maps `next/router` → this file
 * for application code only (not for node_modules).
 */
'use client';

const originalModule = require('next/dist/client/router');
const compatRouter = require('next/compat/router');

// Stub router for when Pages Router context isn't available (App Router mode)
const STUB_ROUTER = {
    route: '/',
    pathname: '/',
    query: {},
    asPath: '/',
    basePath: '',
    locale: 'vi',
    locales: ['vi'],
    defaultLocale: 'vi',
    isReady: true,
    isPreview: false,
    isLocaleDomain: false,
    isFallback: false,
    push: function () { return Promise.resolve(true); },
    replace: function () { return Promise.resolve(true); },
    reload: function () {},
    back: function () {},
    forward: function () {},
    prefetch: function () { return Promise.resolve(); },
    beforePopState: function () {},
    events: {
        on: function () {},
        off: function () {},
        emit: function () {},
    },
};

function safeUseRouter() {
    var router = compatRouter.useRouter();
    return router || STUB_ROUTER;
}

// Re-export everything from the real next/router, overriding useRouter
module.exports = Object.assign({}, originalModule, {
    useRouter: safeUseRouter,
});
